/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MenuNonOrdinarioDTO } from './menu-non-ordinario-dto';
import { CategoriaDipendenteMensa } from './categoria-dipendente-mensa';


export interface CategoriaDTO { 
    categoria?: CategoriaDipendenteMensa;
    numero_pasti_ordinari?: number;
    note?: string;
    menu_non_ordinari?: Array<MenuNonOrdinarioDTO>;
}



